export const API_BASE_URL = import.meta.env.VITE_API_URL ?? '/api/v1';

export const SCORE_THRESHOLDS = {
  excellent: 800,
  good: 600,
  fair: 400,
} as const;

export const SCORE_BANDS = {
  excellent: { label: 'Excellent', min: 800, max: 1000 },
  good: { label: 'Good', min: 600, max: 799 },
  fair: { label: 'Fair', min: 400, max: 599 },
  poor: { label: 'Poor', min: 0, max: 399 },
} as const;

export const TIER_LABELS: Record<string, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
};

export const TOKEN_REFRESH_BUFFER_MS = 60_000; // refresh 1 min before expiry
export const ACCESS_TOKEN_TTL_MS = 15 * 60 * 1000; // 15 min
